import { put, takeEvery, select } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import * as actionTypes from "./constants";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { ToastContainer, toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { Component } from "react";
var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchnotifications(params) {
  let page = (params.params && params.params.page) || 1;
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/Notification?limit=10&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_NOTIFICATIONS_ERROR_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* unreadnotifications(value) {
  let fromPusher = (value.value && value.value.fromPusher) || false;
  let data = (value.value && value.value.data) || null;

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/Notification?read=false`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_UNREADNOTIFICATIONS_SUCCESS_ACTION,
        payload: resJSON,
      });

      if (fromPusher && data.content) {
        const Zoom = cssTransition({
          enter: "zoomIn",
          exit: "zoomOut",
          // default to 750ms, can be omitted
          duration: 750,
        });
        yield toast(
          <p
            style={{
              color: "rgb(5, 51, 76)",
              padding: "9px",
              fontWeight: 600,
              margin: "auto",
            }}
          >
            {/* {resJSON && resJSON.rows[0] && resJSON.rows[0].message} */}
            {data && data.content}
          </p>,

          // data && data.content,
          {
            position: "top-right",
            autoClose: 5000,
            className:"toastClass",
            hideProgressBar: true,
            closeOnClick: true,
            // pauseOnHover: true,
            // draggable: true,
            // progress: undefined,

            // transition: Zoom,
            // autoClose: 3000,
            // duration: [500, 800],
          }
        );
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_UNREADNOTIFICATIONS_ERROR_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateNotification(params) {
  let id = params.params.id;

  const data = {
    read: true,
  };

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/Notification/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.UPDATE_NOTIFICATIONS_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_NOTIFICATIONS_INIT_ACTION,
      });
      yield put({
        type: actionTypes.FETCH_UNREADNOTIFICATIONS_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* notificationActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_NOTIFICATIONS_INIT_ACTION,
    fetchnotifications
  );
  yield takeEvery(
    actionTypes.FETCH_UNREADNOTIFICATIONS_INIT_ACTION,
    unreadnotifications
  );
  yield takeEvery(
    actionTypes.UPDATE_NOTIFICATIONS_INIT_ACTION,
    updateNotification
  );
}
